import { render, staticRenderFns } from "./TerminosDirectoComponent.vue?vue&type=template&id=11f41d44&"
import script from "./TerminosDirectoComponent.vue?vue&type=script&lang=ts&"
export * from "./TerminosDirectoComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TerminosDirectoComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports